import { render, staticRenderFns } from "./AddEditComment.vue?vue&type=template&id=4c47fb2e&"
import script from "./AddEditComment.vue?vue&type=script&lang=js&"
export * from "./AddEditComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports